import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../AppIcon";
import Input from "./Input";
import LanguageSwitcher from "LanguageSwitcher";
import { useTranslation } from "react-i18next"; // Import useTranslation
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllProductsService } from "redux/services/general_service";
import { setProductNull } from "redux/slices/general";
const Header = ({ isScrolled }) => {
  const { metaProducts, productsList, filtersData } = useSelector(
    (state) => state.general
  );

  const { t } = useTranslation(); // Initialize translation

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { metaCart, cartList } = useSelector((state) => state.general);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [products, setProducts] = useState([]);

  const handleSearch = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    try {
      if (searchQuery !== "") {
        await dispatch(getAllProductsService({ search: searchQuery })).then(
          (response) => {
            console.log(response);
            if (response?.payload?.status === 200) {
              console.log(response.payload.data.data);
              setProducts(response?.payload?.data?.data);
            }
            setIsLoading(false);
          }
        );
      } else {
        setProducts([]);
      }
    } catch (err) {
      console.log(err);
      setError("فشل في البحث، جرب تاني");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setIsLoading(true);
    const value = e.target.value;
    setSearchQuery(value);
    if (searchQuery?.length > 1) {
      dispatch(getAllProductsService({ search: value })).then((response) => {
        console.log(response);
        if (response?.payload?.status === 200) {
          console.log(response.payload.data.data);
          setProducts(response?.payload?.data?.data);
        }
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
      setProducts([]);
    }
  };

  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated")
  );

  const [cartCount, setCartCount] = useState(
    isAuthenticated ? cartList?.length : localStorage.getItem("cartCount")
  );

  const location = useLocation();

  const searchRef = useRef(null);
  const categoryRef = useRef(null);
  const userMenuRef = useRef(null);
  const [isShaking, setIsShaking] = useState(false);
  const [isEmptyPulse, setIsEmptyPulse] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      function handleCartUpdated(e) {
        setCartCount(e.detail.count);
      }
      window.addEventListener("cartUpdated", handleCartUpdated);
      // قراءة القيمة الأولية
      const initialCount = parseInt(
        localStorage.getItem("cartCount") || "0",
        10
      );
      setCartCount(initialCount);
      return () => {
        window.removeEventListener("cartUpdated", handleCartUpdated);
      };
    }
  }, []);
  useEffect(() => {
    if (
      cartList?.length > 0 ||
      parseInt(localStorage.getItem("cartCount") || "0") > 0
    ) {
      if (isAuthenticated) {
        setCartCount(cartList?.length);
      } else {
        setCartCount(parseInt(localStorage.getItem("cartCount") || "0"));
      }
      setIsEmptyPulse(false);
      const interval = setInterval(() => {
        setIsShaking(true);
        setTimeout(() => setIsShaking(false), 1000);
      }, 3000);
      return () => clearInterval(interval);
    } else {
      setIsEmptyPulse(true);
    }
    setSearchQuery("");
    dispatch(setProductNull());
  }, [cartList, isAuthenticated]);

  const navigationItems = [
    { path: "/home-page", label: t("navigation.home"), icon: "Home" },
    {
      path: "/product-listing",
      label: t("navigation.products"),
      icon: "Grid3X3",
    },
    {
      path: "/shopping-cart",
      label: t("navigation.cart"),
      icon: "ShoppingCart",
      badge: cartCount,
    },
    { label: t("wishlist"), path: "/wishlist", icon: "Heart" },
    { path: "/login", label: t("navigation.account"), icon: "User " },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchOpen(false);
      }
      if (categoryRef.current && !categoryRef.current.contains(event.target)) {
        setIsCategoryMenuOpen(false);
      }
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUser(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    /* const savedCartCount = localStorage.getItem("cartCount");
    if (savedCartCount) {
      setCartCount(parseInt(savedCartCount));
    }*/

    const authStatus = localStorage.getItem("isAuthenticated");
    setIsAuthenticated(authStatus === "true");
  }, []);
  useEffect(() => {
    console.log(products);
    // setCartCount(cartList?.length);
  }, [cartCount, metaCart, cartList, products]);

  /* const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.location.href = `/product-listing?search=${encodeURIComponent(
        searchQuery
      )}`;
    }
  };*/

  const handleCategorySelect = (categoryId) => {
    setIsCategoryMenuOpen(false);
    window.location.href = `/product-listing?category=${categoryId}`;
  };

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    setIsAuthenticated(false);
    setIsUser(false);
    window.location.href = "/login";
  };

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Desktop Header */}
      <>
          <header
          className="fixed top-0 left-0 right-0 bg-white shadow-md z-50"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              {/* Logo - always visible */}
              <Link
                to="/home-page"
                className="flex items-center space-x-2 hover:opacity-80 transition-smooth"
              >
                <img
                  src="/assets/images/logo.png"
                  alt="logo"
                  className="w-12 h-12 object-cover"
                />
              </Link>

              {/* Desktop Navigation - hidden on small screens */}
              <nav className="hidden lg:flex items-center space-x-8">
                {/* روابط التنقل */}
                <div className="flex flex-col lg:flex-row gap-4 lg:gap-12 justify-center items-center p-4 lg:p-0">
                  <button
                    onClick={() => navigate("/")}
                    role="menuitem"
                    className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
                  >
                    {t("home")}
                  </button>
                  <button
                    onClick={() => navigate("/product-listing")}
                    role="menuitem"
                    className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
                  >
                    {t("categories")}
                  </button>
                  <button
                    onClick={() => navigate("/about-us")}
                    role="menuitem"
                    className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
                  >
                    {t("navigation.aboutUs")}
                  </button>
                  {/*  <button
                    role="menuitem"
                    className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
                  >
                    {t("navigation.contactUs")}
                  </button>*/}
                </div>
              </nav>

              {/* Right Section (Search, Language, User Menu) - hidden on small screens */}
              <div className="hidden lg:flex items-center space-x-4">
                {/* Search */}

                <div className="relative" ref={searchRef}>
                  <form onSubmit={handleSearch} className="relative">
                  
                 

                    {/* قائمة النتائج - حطها هنا داخل الـ form عشان تكون dropdown من السيرش */}
                    {isLoading && (
                      <p className="mt-2 text-sm text-gray-500">
                        جاري البحث...
                      </p>
                    )}
                    {error && (
                      <p className="mt-2 text-sm text-red-500">{error}</p>
                    )}
                    {products && products.length > 0 ? (
                      <ul className="absolute top-full mt-2 w-64 bg-white border border-gray-300 rounded-lg shadow-lg z-50 max-h-60 overflow-y-auto">
                        {products.map((product, index) => (
                          <li
                            key={product.id || index}
                            className="p-2 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
                            onClick={() => {
                              window.location.href = `/product-detail?id=${product.id}`;
                              // navigate(`/product/${product.id}`);
                            }}
                          >
                            {product.name || product.title || "منتج غير معروف"}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      searchQuery &&
                      !isLoading && (
                        <p className="mt-2 text-sm text-gray-500">
                          لا يوجد منتجات مطابقة
                        </p>
                      )
                    )}
                  </form>
                </div>
                {/* Language Switcher 
                <LanguageSwitcher />*/}
                {/* User Menu */}
                <div className="relative" ref={userMenuRef}>
                  <button
                    onClick={() => setIsUser(!isUser)}
                    className="flex items-center space-x-2 p-2 text-text-secondary hover:text-primary transition-smooth"
                  >
                    <Icon
                      name={isAuthenticated ? "User   Check" : "User   "}
                      size={20}
                    />
                    <Icon
                      name="ChevronDown"
                      size={14}
                      className="hidden sm:block"
                    />
                  </button>

                  {isUser && (
                    <div className="absolute top-full right-0 mt-2 w-48 bg-white border border-border rounded-[16px] shadow-lg z-50">
                      <div className="p-2">
                        {isAuthenticated ? (
                          <>
                            <Link
                              to="/edit-profile"
                              className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                            >
                              <Icon name="User   " size={16} />
                              <span>{t("userMenu.myAccount")}</span>
                            </Link>
                            <Link
                              to="/order-history"
                              className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                            >
                              <Icon name="Package" size={16} />
                              <span>{t("userMenu.myOrders")}</span>
                            </Link>
                            <Link
                              to="/wishlist"
                              className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                            >
                              <Icon name="Heart" size={16} />
                              <span>{t("userMenu.wishlist")}</span>
                            </Link>

                            <hr className="my-2 border-border" />
                            <button
                              onClick={handleLogout}
                              className="w-full flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                            >
                              <Icon name="LogOut" size={16} />
                              <span>{t("userMenu.signOut")}</span>
                            </button>
                          </>
                        ) : (
                          <>
                            <Link
                              to="/login"
                              className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                            >
                              <Icon name="LogIn" size={16} />
                              <span>{t("userMenu.signIn")}</span>
                            </Link>
                            <Link
                              to="/register"
                              className="flex items-center space-x-2 px-3 py-2 text-sm text-text-primary hover:bg-muted rounded-md transition-smooth"
                            >
                              <Icon name="User   Plus" size={16} />
                              <span>{t("userMenu.createAccount")}</span>
                            </Link>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Cart - always visible */}
              <Link
                to="/shopping-cart"
                className="relative p-2 text-text-secondary hover:text-primary transition-smooth"
                aria-label="Shopping Cart"
              >
                <Icon
                  name="ShoppingCart"
                  size={20}
                  className={`${isShaking ? "animate-shake" : ""} ${
                    isEmptyPulse ? "animate-pulse-glow" : ""
                  }`}
                />
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-accent text-white text-xs font-medium rounded-full w-5 h-5 flex items-center justify-center">
                    {cartCount > 99 ? "99+" : cartCount}
                  </span>
                )}
              </Link>

              {/* Mobile Menu Toggle - visible only on small screens
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="lg:hidden p-2 text-text-secondary hover:text-primary transition-smooth"
                aria-label="Toggle menu"
              >
                <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={20} />
              </button> */}
            </div>
          </div>

          {/* Mobile Search Overlay */}
          {isSearchOpen && (
            <div className="md:hidden border-t border-border bg-white p-4">
              <form onSubmit={handleSearch} className="relative">
                <Input
                  type="search"
                  placeholder={t("search.placeholder")}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-10"
                  autoFocus
                />
                <Icon
                  name="Search"
                  size={18}
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary"
                />
              </form>
            </div>
          )}

          {/* Mobile Menu Dropdown */}
          {isMobileMenuOpen && (
            <div className="lg:hidden border-t border-border bg-white">
              <nav className="p-4 space-y-4">
                {/* Navigation Links */}
                <button
                  onClick={() => {
                    navigate("/");
                    setIsMobileMenuOpen(false);
                  }}
                  className={`w-full text-left px-3 py-2 rounded-md font-bold ${
                    isActivePath("/")
                      ? "bg-primary/10 text-primary"
                      : "text-text-primary hover:bg-muted"
                  }`}
                >
                  {t("home")}
                </button>
                <button
                  onClick={() => {
                    navigate("/product-listing");
                    setIsMobileMenuOpen(false);
                  }}
                  className={`w-full text-left px-3 py-2 rounded-md font-bold ${
                    isActivePath("/product-listing")
                      ? "bg-primary/10 text-primary"
                      : "text-text-primary hover:bg-muted"
                  }`}
                >
                  {t("categories")}
                </button>
                <button
                  onClick={() => {
                    navigate("/about-us"); // عدل حسب رابط صفحة About Us
                    setIsMobileMenuOpen(false);
                  }}
                  className={`w-full text-left px-3 py-2 rounded-md font-bold ${
                    isActivePath("/about-us")
                      ? "bg-primary/10 text-primary"
                      : "text-text-primary hover:bg-muted"
                  }`}
                >
                  {t("navigation.aboutUs")}
                </button>
                <button
                  onClick={() => {
                    navigate("/contact-us"); // عدل حسب رابط صفحة Contact Us
                    setIsMobileMenuOpen(false);
                  }}
                  className={`w-full text-left px-3 py-2 rounded-md font-bold ${
                    isActivePath("/contact-us")
                      ? "bg-primary/10 text-primary"
                      : "text-text-primary hover:bg-muted"
                  }`}
                >
                  {t("navigation.contactUs")}
                </button>

                {/* Search Input */}
                <form onSubmit={handleSearch} className="relative mt-4">
                  <Input
                    type="search"
                    placeholder={t("search.placeholder")}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full pl-10"
                    autoFocus
                  />
                  <Icon
                    name="Search"
                    size={18}
                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary"
                  />
                </form>

                {/* Language Switcher */}
                <div className="mt-4">
                  <LanguageSwitcher />
                </div>

                {/* User Menu Links */}
                <div className="mt-4 border-t border-border pt-4">
                  {isAuthenticated ? (
                    <>
                      <Link
                        to="/edit-profile"
                        className="block px-3 py-2 text-text-primary hover:bg-muted rounded-md"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        {t("userMenu.myAccount")}
                      </Link>
                      <Link
                        to="/order-history"
                        className="block px-3 py-2 text-text-primary hover:bg-muted rounded-md"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        {t("userMenu.myOrders")}
                      </Link>
                      <Link
                        to="/wishlist"
                        className="block px-3 py-2 text-text-primary hover:bg-muted rounded-md"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        {t("userMenu.wishlist")}
                      </Link>
                      <button
                        onClick={() => {
                          handleLogout();
                          setIsMobileMenuOpen(false);
                        }}
                        className="w-full text-left px-3 py-2 text-text-primary hover:bg-muted rounded-md"
                      >
                        {t("userMenu.signOut")}
                      </button>
                    </>
                  ) : (
                    <>
                      <Link
                        to="/login"
                        className="block px-3 py-2 text-text-primary hover:bg-muted rounded-md"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        {t("userMenu.signIn")}
                      </Link>
                      <Link
                        to="/register"
                        className="block px-3 py-2 text-text-primary hover:bg-muted rounded-md"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        {t("userMenu.createAccount")}
                      </Link>
                    </>
                  )}
                </div>
              </nav>
            </div>
          )}
        </header>
        {/* Spacer for fixed header */}
        <div className="h-16"></div>
        {/* Spacer for mobile bottom navigation */}
        <div className="lg:hidden h-16"></div>
        {/* CSS Animations */}
        <style>
          {`
      @keyframes shake {
        0%, 100% { transform: translateX(0); }
        20%, 60% { transform: translateX(-5px); }
        40%, 80% { transform: translateX(5px); }
      }
      .animate-shake {
        animation: shake 0.5s ease-in-out;
      }
      @keyframes pulseGlow {
        0%, 100% {
          transform: scale(1);
          box-shadow: 0 0 5px rgba(0, 0, 0, 0);
        }
        50% {
          transform: scale(1.1);
          box-shadow: 0 0 8px rgba(128, 128, 128, 0.6);
          border-radius: 50%;
        }
      }
      .animate-pulse-glow {
        animation: pulseGlow 2s infinite;
      }
    `}
        </style>
      </>
    </>
  );
};

export default Header;
